import { render } from "./FormRating.vue?vue&type=template&id=3a893c2f"
import script from "./FormRating.vue?vue&type=script&lang=js"
export * from "./FormRating.vue?vue&type=script&lang=js"
script.render = render

export default script